$(".top-header-slider").slick({
  autoplay: true,
  autoplaySpeed: 0,
  speed: 6000,
  arrows: false,
  swipe: false,
  slidesToShow: 2,
  cssEase: "linear",
  pauseOnFocus: false,
  pauseOnHover: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        speed: 26000,
      },
    },
  ],
});


$(".hero-slider").slick({
  dots: true,
  number:true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  prevArrow:
    '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z" fill="#D6B369"></path></svg></button>',
  nextArrow:
    '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z" fill="#D6B369"></path></svg></button>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1, // Ensure only 1 slide is shown
        slidesToScroll: 1, // Ensure only 1 slide is scrolled
        autoplay: true,
      },
    },
  ],
});

$(document).ready(function () {
  $(".review-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    autoplay: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
          dots: false,
        },
      },
      {
        breakpoint: 559,
        settings: {
          slidesToShow: 1, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
          dots: false,
        },
      },
    ],
  });
  $(".prev-btn").click(function () {
    $(".review-slider").slick("slickPrev");
  });

  $(".next-btn").click(function () {
    $(".review-slider").slick("slickNext");
  });
  $(".prev-btn").addClass("slick-disabled");
  $(".review-slider").on("afterChange", function () {
    if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prev-btn").addClass("slick-disabled");
    } else {
      $(".prev-btn").removeClass("slick-disabled");
    }
    if ($(".slick-next").hasClass("slick-disabled")) {
      $(".next-btn").addClass("slick-disabled");
    } else {
      $(".next-btn").removeClass("slick-disabled");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".variant-select").forEach(function (dropdown) {
    dropdown.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];
      const priceWrapper = this.closest(".card__information").querySelector(".price-wrapper");

      if (selectedOption && priceWrapper) {
        let priceHtml = `<span class="price-item">${selectedOption.dataset.price}</span>`;
        if (selectedOption.dataset.compare !== "null" && selectedOption.dataset.compare !== selectedOption.dataset.price) {
          priceHtml = `<span class="price-item price-item--sale">${selectedOption.dataset.price}</span>
                       <span class="price-item price-item--regular"><s>${selectedOption.dataset.compare}</s></span>`;
        }
        priceWrapper.innerHTML = priceHtml;
      }
    });
  });
});
